import React from 'react';
import S from './Responsive.styles';
const MobileOnly = ({ children }) => {
    return React.createElement(S.MobileOnly, null, children);
};
export default MobileOnly;
